
<div class="side-nav primary"  v-resize="onResize">
    <div class="navbar-brand">
        <a class="white primary--text">LIFTMANAGER</a>
    </div>

    <div class="ml-5 mt-1 mb-1">
        <div>
            <a @click="onLiftmanagement">
                <v-icon color="white" size="20">mdi-elevator-passenger</v-icon>
                <span class="ml-1">Liftmanagement</span>
            </a>
        </div>

        <div v-if="isDispatcher || isRestrictedDispatcher || isDisponent"  class="mt-n1">
            <a @click="onDisposition">
                <v-icon color="white" size="20">mdi-folder-clock-outline</v-icon>
                <span class="ml-1">Disposition</span>
            </a>
        </div>

        <div  class="mt-n1">
            <a @click="onInbox">
                <v-icon color="white" size="20">mdi-inbox</v-icon>
                <span class="ml-1">Inbox</span>
            </a>
        </div>
        <div class="mt-n1">
            <a @click="onOutbox">
                <v-icon color="white" size="20">mdi-inbox-arrow-up</v-icon>
                <span class="ml-1">Outbox</span>
            </a>
        </div>

        <div class="mt-n1">
            <a @click="onSites">
                <v-icon color="white" size="20">mdi-elevator</v-icon>
                <span class="ml-1">Anlagen</span>
            </a>
        </div>
        <div  class="mt-n1">
            <a @click="onPreferences">
                <v-icon color="white" size="20">mdi-wrench-outline</v-icon>
                <span class="ml-1">Einstellungen</span>
            </a>
        </div>
    </div>

    <v-divider class="white mt-1"></v-divider>
    <div style="overflow-y: scroll" :style="'max-height: ' + height + 'px'">
        <div class="ml-5 mt-1 mb-1">
            <div class="sub-title">
                Unternehmen
            </div>
        </div>
        <v-divider class="white mb-1"></v-divider>

        <div class="ml-5 mt-0 mb-0">
            <div>
                <a @click="onCustomer">
                    <v-icon color="white" size="20">mdi-account-group</v-icon>
                    <span class="ml-1">Kunden</span>
                </a>
            </div>

            <div class="mt-n1">
                <a @click="onService">
                    <v-icon color="white" size="20">mdi-cogs</v-icon>
                    <span class="ml-1">Service</span>
                </a>
            </div>

            <div  class="mt-n1">
                <a @click="onInspection">
                    <v-icon color="white" size="20">mdi-clipboard-outline</v-icon>
                    <span class="ml-1">ZÜS</span>
                </a>
            </div>
        </div>

        <v-divider class="white mt-0 mt-2"></v-divider>
        <div class="ml-5 mt-1 mb-1">
            <div class="sub-title">
                Reports
            </div>
        </div>
        <v-divider class="white mb-1"></v-divider>

        <v-expansion-panels accordion flat  class="primary white--text">
            <v-expansion-panel class="primary white--text">
                <v-expansion-panel-header style="color: white; padding-right: 10px;">
                    <v-icon color="white" size="20">mdi-microsoft-excel</v-icon>
                    <span>Excel</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <div>
                        <report-list area="reports" :show="show" :format="1"/>
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel class="primary white--text">
                <v-expansion-panel-header style="color: white; padding-right: 10px;">
                    <v-icon color="white" size="20">mdi-file-pdf-box</v-icon>
                    <span>PDF</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <div>
                        <report-list area="reports" :show="show" :format="2"/>
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <v-divider class="white mt-1" v-if="isDataAdmin"></v-divider>
        <div class="ml-5 mt-1 mb-1" v-if="isDataAdmin">
            <div class="sub-title">
                Stammdaten
            </div>
        </div>
        <v-divider class="white mb-1" v-if="isDataAdmin"></v-divider>
        <v-expansion-panels accordion flat  class="primary white--text" v-if="isDataAdmin">
            <v-expansion-panel class="primary white--text">
                <v-expansion-panel-header style="color: white; padding-right: 10px;">
                    <v-icon color="white" size="20">mdi-database-export</v-icon>
                    <span>Export</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <div>
                        <report-list area="Export" :show="show" :format="1"/>
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel class="primary white--text">
                <v-expansion-panel-header style="color: white; padding-right: 10px;">
                    <v-icon color="white" size="20">mdi-database-import</v-icon>
                    <span>Import</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <div>
                        <c-importer-list class="mb-3" />
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <v-divider class="white mt-1"></v-divider>
        <div class="ml-5 mt-1 mb-1">
            <div class="sub-title">
                Dokumente
            </div>
        </div>
        <v-divider class="white"></v-divider>
        <div class="ml-5 mt-1 mb-1">

            <div>
                <a @click="onDocExport">
                    <v-icon color="white" size="20">mdi-export</v-icon>
                    <span class="ml-1">Export</span>
                </a>
            </div>
            <div class="mt-n1">
                <a @click="onDocuments" >
                    <v-icon color="white" size="20">mdi-book-open-outline</v-icon>
                    <span class="ml-1 mt-1">Browser</span>
                </a>
            </div>
        </div>
        <v-divider class="white mt-0"></v-divider>
    </div>
    <div class="app-version">Liftmanager v{{ appVersion }}</div>
</div>
